import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuizRewardListComponent } from './quiz-reward-list.component';
import { SvgIconModule } from '../svg-icon';

@NgModule({
    declarations: [QuizRewardListComponent],
    exports: [QuizRewardListComponent],
    imports: [
        CommonModule,
        SvgIconModule
    ]
})
export class QuizRewardListModule { }
